import { useState, useEffect, useCallback, useRef } from "react";

function InputAuto({ label, pholder, data, onSelected, onChange, register, name, setValue, clearErrors, error: externalError, showInfo = true, defaultValue }: any) {
    const [suggestions, setSugesstions] = useState<any[]>([]);
    const [isHideSuggs, setIsHideSuggs] = useState(true);
    const [selectedVal, setSelectedVal] = useState("");
    const [hasSelected, setHasSelected] = useState(false);
    const [error, setError] = useState<any>(null);
    const inputRef = useRef<HTMLInputElement>(null);

    const filterSuggestions = (value: string) => {
        if (value.length < 2) {
            setIsHideSuggs(true);
            setSugesstions([]);
            return;
        }
        const filtered = data.filter((i: any) => {
            return i.name.toLocaleLowerCase('tr-TR').includes(value.toLocaleLowerCase('tr-TR'));
        });
        setSugesstions(filtered);
        setIsHideSuggs(filtered.length === 0);
    };

    const handleChange = (e: any) => {
        const input = e.target.value;
        setSelectedVal(input);
        setHasSelected(false);
        filterSuggestions(input);
        if (clearErrors) {
            clearErrors(name);
        }
        if (onChange) {
            onChange(input);
        }
        if (setValue) {
            setValue(name, null);
        }
    };

    const selectSuggestion = (value: any) => {
        if (onSelected) {
            onSelected(value);
        }
        setSelectedVal(value.name);
        setHasSelected(true);
        setIsHideSuggs(true);
        if (setValue) {
            setValue(name, value.id);
        }
    };

    const handleKeyDown = (e: any) => {
        if (!isHideSuggs && suggestions.length > 0) {
            if (e.key === "Escape") {
                setIsHideSuggs(true);
            }
        }
    };

    const handleBlur = (e: any) => {
        setTimeout(() => {
            const exactMatch = data.find((item: any) =>
                item.name.toLocaleLowerCase('tr-TR') === selectedVal.toLocaleLowerCase('tr-TR')
            );

            if (exactMatch) {
                selectSuggestion(exactMatch);
            }

            setIsHideSuggs(true);
        }, 200);
    };

    const handleFocus = (e: any) => {
        if (e.target.value.length >= 2) {
            filterSuggestions(e.target.value);
        }
    };

    const checkValue = useCallback(() => {
        if (!hasSelected && selectedVal.length > 0) {
            setError("Listeden meslek seçimi yapınız.");
        } else {
            setError(null);
        }
    }, [selectedVal, hasSelected]);

    useEffect(() => {
        checkValue();
    }, [selectedVal, checkValue]);

    useEffect(() => {
        // Initialize selectedVal when defaultValue prop changes
         if (defaultValue !== undefined && defaultValue !== null && !selectedVal) {
            const matchingItem = data.find((item: any) => item.id === defaultValue);
            if (matchingItem) {
                setSelectedVal(matchingItem.name);
                setHasSelected(true);
            }
        }
    }, [defaultValue, data]);

    return (
        <div className="sugesstion-auto">
            <div className="form-control-auto">
                <label htmlFor={name || "tag-input"}>
                    {label}
                    {showInfo && <span className="fw-bold nowrap-ellipsis tooltip inline-block mx-2">
                        ?
                        <div className="tooltip-text">
                            Meslek bilginizi seçebilmeniz için mesleğinizin ilk iki harfini yazmanız gerekmektedir. Bazı meslekler
                            aynı anlama gelen farklı ifadelerle tanımlanabildiğinden, meslek listesinin açılmaması hâlinde mesleğinizi
                            farklı bir ifade ile aratmayı deneyebilirsiniz.
                        </div>
                    </span>}
                </label>

                <input
                    {...(register ? register(name, {
                        required: "Bu alan zorunludur",
                        validate: (value: any) => {
                            if (!value && value !== 0) return "Bu alan zorunludur";
                            return true;
                        }
                    }) : {})}
                    id={name || "profession"}
                    ref={inputRef}
                    autoComplete="off"
                    placeholder={pholder}
                    type="search"
                    className={`form-control ${error || externalError ? "border-danger" : ""}`}
                    value={selectedVal}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                />

                {(error || externalError) && (
                    <div className="text-danger">
                        {error || (typeof externalError === 'string' ? externalError : externalError?.message)}
                    </div>
                )}
            </div>

            <div className="suggestions" style={{ display: isHideSuggs ? "none" : "block" }}>
                {suggestions.map((item: any, idx: any) => (
                    <div
                        key={"" + item.id + idx}
                        onClick={() => {
                            selectSuggestion(item);
                        }}
                    >
                        {item.name}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default InputAuto;